import { isTransportError, useOpenWindow } from '@krp/client-runtime'
import {
  OWN_CASHIERS_WINDOWS, OWN_CASHIER_NEW, OwnCashiersListScreen, ownCashiersPatched, receiptsPeople, type OwnCashiersIntent,
} from '@krp/resource-receipts-ui'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { useMyAccess } from '../platform/useMyAccess'

const errorText = (error: unknown) => isTransportError(error) ? error.message : error instanceof Error ? error.message : error === undefined ? null : 'Не удалось получить ответ сервера'

/**
 * Список кассиров нашей системы (RP-CU3): строка открывает карточку модальным окном (`?w=receipts.people.card:<id>`), «Новый кассир» — та же
 * карточка с id «new». Намерение списка (поиск, показывать ли архивных) — в слайсе окна; кассиры — в кэше запроса.
 */
export function OwnCashiersListBinding() {
  const dispatch = useAppDispatch()
  const access = useMyAccess()
  const openWindow = useOpenWindow()
  const intent = useAppSelector((state) => state.receipts.ownCashiers)
  const patch = (value: Partial<OwnCashiersIntent>) => { dispatch(ownCashiersPatched(value)) }
  const list = receiptsPeople.useQuery()
  const canManage = access.data?.api.includes('platform:cashiers:manage') === true && list.data?.canManage === true
  return <OwnCashiersListScreen list={list.data} loading={list.isFetching} canManage={canManage}
    error={errorText(list.error ?? access.error)}
    search={intent.search} find={(value) => patch({ search: value })}
    showArchived={intent.showArchived} toggleArchived={(value) => patch({ showArchived: value })}
    reload={() => void list.refetch()}
    open={(id) => openWindow(OWN_CASHIERS_WINDOWS.card, { id })}
    openNew={() => openWindow(OWN_CASHIERS_WINDOWS.card, { id: OWN_CASHIER_NEW })} />
}
